export default {"src":"/_next/static/media/egypt.599175db.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};